import { EnvironmentConfig, EnvironmentStatus } from "src/classes/EnvironmentHelper";

export const ENVIRONMENT: EnvironmentConfig = {
  DEBUG: true,
  STATUS: EnvironmentStatus.DEVELOPMENT,
};
